import React, { useEffect, useRef, useState } from 'react';
import "./loginsignup.css";

const SignUpPage = () => {
    const [formData, setFormData] = useState({
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        password: '',
        confirmPassword: ''
    });

    const [errors, setErrors] = useState({
        password: '',
        confirmPassword: ''
    });

    const [successMessage, setSuccessMessage] = useState('');
    const LeftRef = useRef();
    const RightRef = useRef();

    const [isLeftVisible, setIsLeftVisible] = useState(false);
    const [isRightVisible, setIsRightVisible] = useState(false);

    useEffect(() => {
        const LeftObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsLeftVisible(true);
                    LeftObserver.unobserve(entry.target);
                }
            });
        });

        const RightObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsRightVisible(true);
                    RightObserver.unobserve(entry.target);
                }
            });
        });

        if (LeftRef.current) {
            LeftObserver.observe(LeftRef.current);
        }

        if (RightRef.current) {
            RightObserver.observe(RightRef.current);
        }

        return () => {
            if (LeftRef.current) {
                LeftObserver.unobserve(LeftRef.current);
            }

            if (RightRef.current) {
                RightObserver.unobserve(RightRef.current);
            }
        };
    }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });

        if (id === "password") {
            validatePassword(value);
        }

        if (id === "confirmPassword") {
            validateConfirmPassword(value);
        }
    };

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
        if (!passwordRegex.test(password)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                password: "Password must be at least 8 characters, contain one uppercase letter and one number."
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
        }
    };

    const validateConfirmPassword = (confirmPassword) => {
        if (confirmPassword !== formData.password) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                confirmPassword: "Passwords do not match."
            }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: "" }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!errors.password && !errors.confirmPassword && formData.password) {
            setSuccessMessage("Sign up successful!");
            console.log("Form submitted:", formData);
        } else {
            setSuccessMessage('');
        }
    };

    return (
        <div className="login-signup-main-container">
            <div className='md:grid grid-cols-2'>
                <div className={`login-signup-left-container flex items-center relative  ${isLeftVisible ? "fade-in" : ""}`} ref={LeftRef}>
                    <div className="absolute -right-9 top-16 h-[145px] w-[190px] bg-[radial-gradient(#cacccc_3px,transparent_3px)] [background-size:16px_16px] z-2"></div>
                    <div className='signup-img1 z-3'></div>
                    <div className="absolute bottom-0 left-0 h-0 w-0 border-[100px] border-transparent border-b-[#DAA520] border-l-[#DAA520] z-2"></div>
                </div>

                <div className={`login-signup-right-container ${isRightVisible ? "fade-in" : ""}`} ref={RightRef}>
                    <h1 className='login-signup-title1'>Join the Future of AI Innovation!</h1>
                    <p className='login-signup-text1'>Be part of a thriving AI startup ecosystem. Connect, collaborate, and scale your projects with like-minded innovators. Sign up today!</p>

                    <form className="login-signup-form" onSubmit={handleSubmit}>
                        <div className='grid grid-cols-2 gap-4'>
                            <div className="form-group">
                                <label htmlFor="firstname" className="login-signup-label">First name</label>
                                <input type="text" id="firstname" value={formData.firstname} onChange={handleChange} placeholder="Enter your first name" className="login-signup-input" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="lastname" className="login-signup-label">Last name</label>
                                <input type="text" id="lastname" value={formData.lastname} onChange={handleChange} placeholder="Enter your last name" className="login-signup-input" required />
                            </div>
                        </div>

                        {/* <div className="form-group">
                            <label htmlFor="username" className="login-signup-label">Username</label>
                            <input type="text" id="username" value={formData.username} onChange={handleChange} placeholder="Enter your username" className="login-signup-input" required />
                        </div> */}

                        <div className="form-group">
                            <label htmlFor="email" className="login-signup-label">Email</label>
                            <input type="email" id="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" className="login-signup-input" required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password" className="login-signup-label">Password</label>
                            <input type="password" id="password" value={formData.password} onChange={handleChange} placeholder="Enter your password" className="login-signup-input" required />
                            {errors.password && <small className="error-text text-red-600">{errors.password}</small>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword" className="login-signup-label">Confirm Password</label>
                            <input type="password" id="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Retype your password" className="login-signup-input" required />
                            {errors.confirmPassword && <small className="error-text text-red-600">{errors.confirmPassword}</small>}
                        </div>

                        {successMessage && <p className="success-message text-green-700 mt-3">{successMessage}</p>}

                        <div className="flex justify-content-center">
                            <button type="submit" className="login-signup-button">Sign Up</button>
                        </div>
                    </form>

                    <p className='login-signup-text2'>Already have an account? <a href="/login" className='login-signup-link'>Login!</a></p>
                </div>
            </div>
        </div>
    );
};

export default SignUpPage;
